import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMenu, FiLogOut, FiUser } from 'react-icons/fi';
import './Navbar.css';

const Navbar = ({ toggleSidebar }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <button className="menu-btn" onClick={toggleSidebar}>
                    <FiMenu size={24} />
                </button>
                <Link to="/" className="navbar-brand">Degash Admin</Link>
            </div>
            <div className="navbar-right">
                <span className="user-info">
                    <FiUser size={18} /> {user?.fullName || 'Admin'}
                </span>
                <button className="logout-btn" onClick={handleLogout}>
                    <FiLogOut size={18} /> Logout
                </button>
            </div>
        </nav>
    );
};

export default Navbar;